import { createAction } from "@reduxjs/toolkit";
import * as ACTIONTYPES from "../action-types/pushs";

const PUSHS_GET_REQUEST_ACTION = createAction(ACTIONTYPES.PUSHS_GET_REQUEST);
const PUSHS_GET_SUCCESS_ACTION = createAction<any, string>(ACTIONTYPES.PUSHS_GET_SUCCESS);
const PUSHS_GET_ERROR_ACTION = createAction<any, string>(ACTIONTYPES.PUSHS_GET_ERROR);

export { PUSHS_GET_REQUEST_ACTION, PUSHS_GET_SUCCESS_ACTION, PUSHS_GET_ERROR_ACTION };
